import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import config from '../../../config';
import { Footer, PageBootstrap } from '../../../components';
import { Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';

import { TopbarContainer } from '../..';
import metaImage from '../img/og/ogimage1200.jpg';

import { AdventureCard, cardsSummer, cardsWinter } from '../components/AdventureCard';

import { propTypes } from '../../../util/types';

import '../AdventurePage.scss';

import hero from '../img/adventures/hero.svg';

import SectionComponent from '../components/SectionComponent';

export const AdventuresPageComponent = props => {
  const { intl } = props;

  const schemaTitle = intl.formatMessage({ id: 'Adventures.OgTitle' });
  const schemaDescription = intl.formatMessage({ id: 'Adventures.OgDescription' });
  const schemaImage = `${config.canonicalRootURL}${metaImage}`;

  return (
    <PageBootstrap
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: metaImage }]}
      twitterImages={[{ url: schemaImage }]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Adventure',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <TopbarContainer />

      <SectionComponent>
        <Row className="py-3 justify-content-md-center">
          <Col lg={8} className="text-center ">
            <Image src={hero} fluid className="py-1 adventures-header-img" />
          </Col>
        </Row>
        <Row className="py-3 justify-content-md-center">
          <Col lg={8} className="text-center">
            <p className="banner-subtitle">
              <FormattedMessage id="AdventuresPage.subtitle" />
            </p>
          </Col>
        </Row>
      </SectionComponent>

      <SectionComponent className="p-0" id="about" title="Winter Adventures" fluid>
        <Row className="py-3 justify-content-md-center">
          <Col lg={8} className="text-center">
            <p className="banner-subtitle">
              <FormattedMessage id="AdventuresPage.winterSeasonSubtitle" />
            </p>
          </Col>
        </Row>

        <Row className="py-3 g-5 justify-content-center ">
          {cardsWinter.map(card => (
            <Col lg={4} key={card.stringKey}>
              <AdventureCard {...card} />
            </Col>
          ))}
        </Row>
      </SectionComponent>

      <SectionComponent className="p-0" title="Green Season Adventures" fluid>
        <Row className="py-3 justify-content-md-center">
          <Col lg={8} className="text-center">
            <p className="banner-subtitle">
              <FormattedMessage id="AdventuresPage.greenSeasonSubtitle" />
            </p>
          </Col>
        </Row>

        <Row className="py-3 g-5 justify-content-md-center">
          {cardsSummer.map(card => (
            <Col lg={4} key={card.stringKey}>
              <AdventureCard {...card} />
            </Col>
          ))}
        </Row>
      </SectionComponent>

      <Footer showBanner={false} />
    </PageBootstrap>
  );
};

const { bool, object } = PropTypes;

AdventuresPageComponent.propTypes = {
  currentUser: propTypes.currentUser,

  // from withRouter
  history: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const AdventuresPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(AdventuresPageComponent);

export default AdventuresPage;
